import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingMilestoneView } from '@euler/model/coaching-progress';
import { Award } from 'lucide-react-native';
import { memo, useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';
import { aiColors, tint } from '../../../ai-suite/theme';
import { milestoneTitle } from '../progressCopy';

/** What this practice earned, as a moment in its report. */
export const MilestoneBanner = memo(
  ({ milestones }: { milestones: CoachingMilestoneView[] }) => {
    const { rpx } = useResponsiveContext();
    const pop = useRef(new Animated.Value(0)).current;
    useEffect(() => {
      Animated.spring(pop, {
        toValue: 1,
        friction: 5,
        delay: 700,
        useNativeDriver: true,
      }).start();
    }, [pop]);
    return (
      <Animated.View
        style={{
          gap: rpx(8),
          padding: rpx(14),
          borderRadius: rpx(14),
          backgroundColor: tint(aiColors.amber, 0.12),
          opacity: pop,
          transform: [
            {
              scale: pop.interpolate({
                inputRange: [0, 1],
                outputRange: [0.92, 1],
              }),
            },
          ],
        }}
      >
        {milestones.map(x => (
          <View
            key={x.id}
            style={{ flexDirection: 'row', alignItems: 'center', gap: rpx(8) }}
          >
            <Award size={rpx(18)} color={aiColors.amber} />
            <Typography.Text size={rpx(14)} bold color={aiColors.foreground}>
              {milestoneTitle(x)}
            </Typography.Text>
          </View>
        ))}
      </Animated.View>
    );
  },
);
